<div class="content">
  <!-- Begin dashboard -->
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="row ">
      <div class="col d-flex align-items-center justify-content-between mb-4">
        <h1 class="dashboard-title">User Work Allocation</h1>
      </div>
    </div>

    <!-- Content Row -->
    <div class="row align-items-center work-allocation-toolbar">
      <!-- <div class="col-12 d-flex align-items-center justify-content-between"> -->
        <!-- Search Box -->
        <div class="col-md-12 col-sm-12 toolbar-search-column"
             [ngClass]="assignArray.length !== 0 ? 'col-lg-5' : 'col-lg-6'">
          <div class="google-search-container">

            <i class="fa fa-search search-icon"></i>

            <input
              (keyup)="handleKeyUp($event)"
              #searchBox
              class="google-search-input"
              type="text"
              placeholder="Search"
              [value]="searchString || ''"
            />

            <i
              *ngIf="searchBox.value"
              class="fa fa-times clear-icon"
              (click)="clearSearch(searchBox)"
            ></i>

          </div>
        </div>
        <!--<div class="col-lg-4 col-md-5 col-sm-12">
            <div class="form-group app-search">
                <div class="position-relative search-wrapper">
                    <input (keyup)="onKeyUp($event)" #searchBox class="form-control search-input" placeholder="Search" type="text">
                    <button *ngIf="searchBox.value" class="btn search-btn" (click)="onSearch()">
                        <i class="fa fa-search"></i>&nbsp;
                    </button>
                </div>
            </div>
        </div>-->

        <!-- Agent assignment -->
        <div class="col-lg-3 col-md-6 col-sm-12 toolbar-agent-column">
          <fieldset [disabled]="!authService.hasRole('client-edit')" class="w-100">
            <div class="assignment-control-row">
              <mat-form-field appearance="outline" class="dropdown-select assignment-select">
                <span matPrefix class="assignment-select-prefix">
                  <i class="fa-regular fa-user"></i>
                </span>

                <mat-select
                  [(ngModel)]="userId"
                  placeholder="Select Agent"
                  panelClass="assignment-select-panel"
                  [disableOptionCentering]="true"
                  [disabled]="!authService.hasRole('client-edit')">

                  <!-- Always show selected agent name -->
                  <mat-select-trigger>
                    <span class="assignment-selected-text">
                      {{ getAssignmentAgentName(userId) }}
                    </span>
                  </mat-select-trigger>

                  <mat-select-filter
                    #assignFilterSelect
                    [array]="agentArray"
                    [displayMember]="'fullName'"
                    (filteredReturn)="onAssignmentFilteredReturn($event)">
                  </mat-select-filter>

                  <mat-option
                    *ngFor="let agent of assignmentAgentArray; trackBy: trackByAgentId"
                    [value]="agent.id">
                    {{ agent.firstName }} {{ agent.lastName }}
                  </mat-option>

                </mat-select>
              </mat-form-field>

              <div *ngIf="assignArray.length !== 0" class="assignment-actions">
                <button
                  type="button"
                  class="assignment-icon-btn assignment-icon-btn-primary"
                  (click)="assignAgent(true)"
                  [disabled]="!userId"
                  title="Assign selected patients">
                  <i class="fa-solid fa-user-check"></i>
                </button>
                <button
                  type="button"
                  class="assignment-icon-btn"
                  (click)="assignAgent(false)"
                  title="Un-assign selected patients">
                  <i class="fa-solid fa-user-minus"></i>
                </button>
              </div>
            </div>
          </fieldset>
        </div>

        <!-- Filter and Add Buttons -->
        <div class="col-md-6 col-sm-12 toolbar-actions-column"
             [ngClass]="assignArray.length !== 0 ? 'col-lg-4' : 'col-lg-3'">
          <div
            class="action-bar"
            [ngClass]="{'has-toggle': assignArray.length !== 0}">

            <div *ngIf="assignArray.length !== 0" class="selection-actions">
              <button
                type="button"
                class="toolbar-btn toolbar-btn-success"
                (click)="changeStatus(true)"
                title="Recover selected patients">
                <i class="fa-solid fa-rotate-left"></i>
                <span class="btn-label">Recover</span>
              </button>
              <button
                type="button"
                class="toolbar-btn toolbar-btn-danger"
                (click)="changeStatus(false)"
                title="Delete selected patients">
                <i class="fa-solid fa-trash-can"></i>
                <span class="btn-label">Delete</span>
              </button>
            </div>

            <div class="dropdown-container" #dropdownContainer>
              <button
                class="toolbar-btn toolbar-btn-light btn-filter"
                [class.active]="isDropdownOpen"
                type="button"
                (click)="toggleDropdown()"
                title="Filters">
                <i class="fa-solid fa-sliders"></i>
                <span class="btn-label">Filters</span>
                <span *ngIf="activeFilterCount > 0" class="filter-count">{{ activeFilterCount }}</span>
              </button>

              <div
                class="filter-popover"
                [hidden]="!isDropdownOpen"
                (click)="$event.stopPropagation()">

                <div class="filter-popover-header">
                  <div>
                    <div class="filter-title-row">
                      <span class="filter-title">Filters</span>
                      <span *ngIf="activeFilterCount > 0" class="filter-summary-badge">
                        {{ activeFilterCount }} active
                      </span>
                    </div>
                    <div class="filter-subtitle">Combine filters and apply them together.</div>
                  </div>
                  <button
                    type="button"
                    class="icon-close-btn"
                    aria-label="Close filters"
                    (click)="toggleDropdown()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>

                <div class="filter-popover-body">
                  <!-- Appointment date -->
                  <div class="filter-section">
                    <div class="filter-section-heading">
                      <span class="filter-section-icon"><i class="fa-regular fa-calendar"></i></span>
                      <div>
                        <div class="filter-section-title">Appointment Date</div>
                        <div class="filter-section-hint">Filter by scheduled appointment date.</div>
                      </div>
                    </div>
                    <div class="filter-date-grid">
                      <div class="filter-field">
                        <label for="startDate">From</label>
                        <div class="date-input-wrap">
                          <i class="fa-regular fa-calendar-days"></i>
                          <input
                            type="text"
                            id="startDate"
                            #startDate
                            class="form-control filter-date-input"
                            placeholder="MM/DD/YYYY"
                            bsDatepicker
                            [(ngModel)]="filter.startDate"
                            [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', placement: 'bottom', containerClass: 'theme-blue'}">
                        </div>
                      </div>
                      <div class="filter-field">
                        <label for="endDate">To</label>
                        <div class="date-input-wrap">
                          <i class="fa-regular fa-calendar-days"></i>
                          <input
                            type="text"
                            id="endDate"
                            #endDate
                            class="form-control filter-date-input"
                            placeholder="MM/DD/YYYY"
                            bsDatepicker
                            [(ngModel)]="filter.endDate"
                            [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', placement: 'bottom', containerClass: 'theme-blue'}"
                            [minDate]="filter.startDate">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Work order date -->
                  <div class="filter-section">
                    <div class="filter-section-heading">
                      <span class="filter-section-icon"><i class="fa-regular fa-clock"></i></span>
                      <div>
                        <div class="filter-section-title">Work Order Date</div>
                        <div class="filter-section-hint">Filter by work order creation date.</div>
                      </div>
                    </div>
                    <div class="filter-date-grid">
                      <div class="filter-field">
                        <label for="wstartDate">From</label>
                        <div class="date-input-wrap">
                          <i class="fa-regular fa-calendar-days"></i>
                          <input
                            type="text"
                            id="wstartDate"
                            #wstartDate
                            class="form-control filter-date-input"
                            placeholder="MM/DD/YYYY"
                            bsDatepicker
                            [(ngModel)]="filter.wStartDate"
                            [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', placement: 'bottom', containerClass: 'theme-blue'}">
                        </div>
                      </div>
                      <div class="filter-field">
                        <label for="wendDate">To</label>
                        <div class="date-input-wrap">
                          <i class="fa-regular fa-calendar-days"></i>
                          <input
                            type="text"
                            id="wendDate"
                            #wendDate
                            class="form-control filter-date-input"
                            placeholder="MM/DD/YYYY"
                            bsDatepicker
                            [(ngModel)]="filter.wEndDate"
                            [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', placement: 'bottom', containerClass: 'theme-blue'}"
                            [minDate]="filter.wStartDate">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Status -->
                  <div class="filter-section compact-section">
                    <div class="filter-section-label">Status</div>
                    <div class="filter-choice-row three-cols">
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.status === true"
                        (click)="filter.status = true">
                        Active
                      </button>
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.status === false"
                        (click)="filter.status = false">
                        Inactive
                      </button>
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.status === null"
                        (click)="filter.status = null">
                        All
                      </button>
                    </div>
                  </div>

                  <!-- Verification -->
                  <div class="filter-section compact-section">
                    <div class="filter-section-label">Verification</div>
                    <div class="filter-choice-row verification-grid">
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="!filter.verification"
                        (click)="filter.verification = null">
                        Any
                      </button>
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.verification === 'VERIFIED'"
                        (click)="filter.verification = 'VERIFIED'">
                        Verified
                      </button>
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.verification === 'PENDING'"
                        (click)="filter.verification = 'PENDING'">
                        In Progress
                      </button>
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.verification === 'NOT_VERIFIED'"
                        (click)="filter.verification = 'NOT_VERIFIED'">
                        Not Verified
                      </button>
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.verification === 'BACKLOG'"
                        (click)="filter.verification = 'BACKLOG'">
                        Backlog
                      </button>
                      <button
                        type="button"
                        class="filter-choice"
                        [class.active]="filter.verification === 'UNASSIGNED'"
                        (click)="filter.verification = 'UNASSIGNED'">
                        Unassigned
                      </button>
                    </div>
                  </div>

                  <!-- Patient benefit domain -->
                  <div class="filter-section compact-section">
                    <div class="filter-section-label">Patient Benefit Type</div>
                    <div class="filter-choice-row three-cols" role="group" aria-label="Patient benefit type">
                      <button type="button" class="filter-choice"
                              [class.active]="filter.patientBenefitType === 'DENTAL'"
                              [attr.aria-pressed]="filter.patientBenefitType === 'DENTAL'"
                              (click)="filter.patientBenefitType = 'DENTAL'">Dental</button>
                      <button type="button" class="filter-choice"
                              [class.active]="filter.patientBenefitType === 'MEDICAL'"
                              [attr.aria-pressed]="filter.patientBenefitType === 'MEDICAL'"
                              (click)="filter.patientBenefitType = 'MEDICAL'">Medical</button>
                      <button type="button" class="filter-choice"
                              [class.active]="filter.patientBenefitType === 'BOTH'"
                              [attr.aria-pressed]="filter.patientBenefitType === 'BOTH'"
                              (click)="filter.patientBenefitType = 'BOTH'">Both</button>
                    </div>
                  </div>

                  <!-- Payer -->
                  <div class="filter-section compact-section agent-filter-section" (click)="$event.stopPropagation()">
                    <div class="filter-section-label d-flex justify-content-between align-items-center">
                      <span>Payer Name</span>
                      <span *ngIf="filter.payerIds?.length" class="selected-count-text">
                        {{ filter.payerIds.length }} selected
                      </span>
                    </div>
                    <mat-form-field appearance="outline" class="agent-filter-field w-100">
                      <mat-select
                        [(ngModel)]="filter.payerIds"
                        multiple
                        placeholder="Search and select payers"
                        [disableOptionCentering]="true"
                        panelClass="agent-multi-select-panel"
                        (click)="$event.stopPropagation()"
                        (selectionChange)="onPayerSelectionChange()"
                        (openedChange)="isPayerSelectOpen = $event">
                        <mat-select-trigger>
                          <span *ngIf="filter.payerIds?.length === 1">1 payer selected</span>
                          <span *ngIf="(filter.payerIds?.length || 0) > 1">{{ filter.payerIds.length }} payers selected</span>
                        </mat-select-trigger>
                        <mat-select-filter
                          [array]="payerArray"
                          [displayMember]="'name'"
                          (filteredReturn)="onPayerFilteredReturn($event)"
                          (click)="$event.stopPropagation()">
                        </mat-select-filter>
                        <mat-option *ngFor="let payer of filterPayerArray; trackBy: trackByPayerId" [value]="payer.id">
                          {{ payer.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- Agents -->
                  <div class="filter-section compact-section agent-filter-section" (click)="$event.stopPropagation()">
                    <div class="filter-section-label d-flex justify-content-between align-items-center">
                      <span>Agents</span>
                      <span *ngIf="filter.agent?.length" class="selected-count-text">
                        {{ filter.agent?.length }} selected
                      </span>
                    </div>

                    <mat-form-field appearance="outline" class="agent-filter-field w-100">
                      <mat-select
                        [(ngModel)]="filter.agent"
                        multiple
                        placeholder="Search and select agents"
                        [disableOptionCentering]="true"
                        panelClass="agent-multi-select-panel"
                        (click)="$event.stopPropagation()"
                        (selectionChange)="onFilterAgentSelectionChange()"
                        (openedChange)="isAgentSelectOpen = $event">

                        <mat-select-trigger>
                          <span *ngIf="filter.agent?.length === 1">
                            {{ getAgentDisplayName(filter.agent[0]) }}
                          </span>
                          <span *ngIf="(filter.agent?.length || 0) > 1">
                            {{ filter.agent?.length }} agents selected
                          </span>
                        </mat-select-trigger>

                        <mat-select-filter
                          #multipleAgentFilterSelect
                          [array]="agentArray"
                          [displayMember]="'fullName'"
                          (filteredReturn)="onFilterAgentFilteredReturn($event)"
                          (click)="$event.stopPropagation()">
                        </mat-select-filter>

                        <mat-option
                          *ngFor="let agent of filterAgentArray; trackBy: trackByAgentId"
                          [value]="agent.id">
                          {{ agent.firstName }} {{ agent.lastName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="filter-popover-footer">
                  <button
                    type="button"
                    class="toolbar-btn toolbar-btn-light filter-footer-btn"
                    (click)="resetFilter($event)">
                    <i class="fa-solid fa-rotate-left"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    class="toolbar-btn toolbar-btn-primary filter-footer-btn"
                    (click)="applyFilters()">
                    <i class="fa-solid fa-check"></i>
                    Apply Filters
                  </button>
                </div>
              </div>
            </div>

            <button
              class="toolbar-btn toolbar-btn-light btn-upload"
              type="button"
              (click)="openModal()"
              title="Bulk Upload"
              [disabled]="!authService.hasRole('client-edit')">
              <i class="fa-solid fa-cloud-arrow-up"></i>
              <span class="btn-label">Bulk Upload</span>
            </button>

            <button
              class="toolbar-btn toolbar-btn-primary btn-add-patient"
              type="button"
              routerLink="register"
              title="Add Patient"
              [disabled]="!authService.hasRole('client-edit')">
              <i class="fas fa-plus"></i>
              <span class="btn-label">Add Patient</span>
            </button>
          </div>
        </div>
      <!-- </div> -->


      <!-- Table -->
      <div class="col-12">
          <div class="table-panel p-4">
            <div class="table-responsive table-scroll-x">
              <table
                class="table table-sm"
                matSort
                [matSortActive]="sortField || ''"
                [matSortDirection]="sortDirection || ''"
                (matSortChange)="sortData($event)">
                <thead>
                <tr >
                  <th scope="col">Sr.No</th>
                  <th scope="col">View</th>
                  <th scope="col">Batch-Status</th>
                  <th *ngIf="this.authService.hasRole('client-edit')" scope="col"><input
                    type="checkbox" [checked]="checked" (click)="assign('All')">&nbsp;
                    Select
                  </th>
                  <th scope="col">Assigned-To</th>
                  <th scope="col">Verification</th>
                  <th scope="col" class="audit-review-status-heading">Audit Review</th>
                  <th mat-sort-header="firstName" scope="col">Name</th>
                  <th mat-sort-header="dob" scope="col">DOB</th>
                  <th mat-sort-header="patientId" scope="col">PatientId</th>
                  <th mat-sort-header="formType" scope="col">Form Type</th>
                  <th mat-sort-header="insuranceType" scope="col">Ins-Type</th>
                  <th mat-sort-header="payerName" scope="col">Career Name</th>
                  <th mat-sort-header="careerName" scope="col">Payer ID</th>
                  <th mat-sort-header="insuranceID" scope="col">Ins-Id</th>
                  <th mat-sort-header="insurancePhone" scope="col">Ins-phone</th>
                  <th mat-sort-header="apptDate" scope="col">App-Date</th>
                  <th mat-sort-header="apptTime" scope="col">App-Time</th>
                  <th mat-sort-header="providerName" scope="col">Provider Name</th>
                  <th mat-sort-header="officeName" scope="col">Office</th>
                  <th mat-sort-header="groupNo" scope="col">Grp-No</th>
                  <th mat-sort-header="formFillTime">Timing</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let table of tableData; let i = index; trackBy: trackByTableId"
                    [ngClass]="{ 'urgent-row': table.urgency === 'URGENT' }" >
                  <th scope="row">{{i + 1}}</th>
                  <td>
                    <a title="Edit"
                       [routerLink]="this.authService.hasRole('client-edit')?['/userworkarea/details/', table.id]:null" [queryParams]="{form:'patient', officeId: table.officeId, planCreation: table.planCreation}"><i
                      class="fa-regular fa-eye"></i></a>
                  </td>
                  <td>
                    <ng-container [ngSwitch]="table.batchJobStatus">
                      <span *ngSwitchCase="'SUCCESS'" class="badge-soft badge-verified">Success</span>
                      <span *ngSwitchCase="'PENDING'" class="badge-soft badge-pending"
                        matTooltip="{{ table.apiErrorMessage || 'No pending details available' }}"
                              matTooltipPosition="above"
                              matTooltipClass="form-types-tooltip">
                        Pending
                      </span>
                      <span *ngSwitchCase="'FAILED'"
                            class="badge-soft badge-backlog"
                            matTooltip="{{ table.apiErrorMessage || 'No pending details available' }}"
                            matTooltipPosition="above"
                            matTooltipClass="form-types-tooltip">
                        Failed
                      </span>
                      <span *ngSwitchDefault class="text-muted">-</span>
                    </ng-container>
                  </td>
                  <td *ngIf="this.authService.hasRole('client-edit')">
                    <input
                      type="checkbox"
                      [checked]="table.assignedF"
                      (change)="assign(table.id)">
                  </td>
                  <td>{{table.staffName ? table.staffName : 'N/A'}}</td>

                  <td>
                    <ng-container [ngSwitch]="table.verification">
                      <span *ngSwitchCase="'VERIFIED'" class="badge-soft badge-verified">Verified</span>
                      <span *ngSwitchCase="'PENDING'" class="badge-soft badge-pending">In Progress</span>
                      <span *ngSwitchCase="'NOT_VERIFIED'" class="badge-soft badge-notverified">Not Verified</span>
                      <span *ngSwitchCase="'BACKLOG'" class="badge-soft badge-backlog">Backlog</span>
                      <span *ngSwitchCase="'UNASSIGNED'" class="badge-soft badge-unassigned">Unassigned</span>
                      <span *ngSwitchDefault class="text-muted">-</span>
                    </ng-container>
                  </td>

                  <td class="audit-review-status-cell">
                    <div *ngIf="table.auditChangesRequested === true; else noAuditChanges"
                         class="audit-review-flag"
                         [matTooltip]="table.auditChangesRequestedAt
                           ? ('Changes requested on ' + (table.auditChangesRequestedAt | date:'MMM d, y, h:mm a'))
                           : 'Changes requested by auditor'"
                         matTooltipPosition="above">
                      <span class="audit-review-flag-badge">
                        <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
                        Changes Requested
                      </span>
                      <small *ngIf="table.auditChangesRequestedAt" class="audit-review-flag-time">
                        {{ table.auditChangesRequestedAt | date:'MMM d, y' }}
                      </small>
                    </div>
                    <ng-template #noAuditChanges>
                      <span class="audit-review-no-flag" title="No audit changes requested">-</span>
                    </ng-template>
                  </td>
                  <td>
                    <a [routerLink]="this.authService.hasRole('client-edit')?['details/', table.id]:null" [queryParams]="{ officeId: table.officeId, planCreation: table.planCreation }">{{table.firstName ? table.firstName + ' ' + table.lastName : '-'}}</a>
                  </td>
                  <td>{{ table.dob ? (table.dob | date: 'MM/dd/yyyy') : '-' }}</td>
                  <td>{{table.patientId ? table.patientId : '-'}}</td>
                  <td>{{table.formType ? table.formType : '-'}}</td>
                  <td>{{table.insuranceType ? table.insuranceType : '-'}}</td>
                  <td>{{table.payerName ? table.payerName : '-'}}</td>
                  <td>{{table.careerName ? table.careerName : '-'}}</td>
                  <td>{{table.insuranceId ? table.insuranceId : '-'}}</td>
                  <td>{{table.insurancePhone ? table.insurancePhone : '-'}}</td>
                  <td>{{table.apptDate ? (table.apptDate | date:'MM/dd/yyyy') : '-'}}</td>
                  <td>{{table.apptTime ? table.apptTime : '-'}}</td>
                  <td>{{table.providerName ? table.providerName : '-'}}</td>
                  <td>{{table.officeName ? table.officeName : '-'}}</td>
                  <td>{{table.groupNo ? table.groupNo : '-'}}</td>
                  <td>
                     {{ table.formFillTime ? formatTime(table.formFillTime) : '-' }}
                  </td>
                  <td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                              style="color: #34ce57"></i></td>
                  <td *ngIf="!table.active"><i class="fa-solid fa-square-xmark"
                                               style="color: #dc3545"></i></td>

                  <td>
                    <a title="Edit"
                       [routerLink]="this.authService.hasRole('client-edit')?['details/', table.id]:null"><i
                      class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;
                  </td>
                </tr>
<!--                </tbody>-->
<!--                <tbody *ngIf="tableData?.length === 0">-->
                <tr *ngIf="tableData?.length === 0">
                  <td [attr.colspan]="this.authService.hasRole('client-edit') ? 24 : 23" class="text-center">
                    No record found !
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!--<div *ngIf="tableData.length !== 0" class="d-flex justify-content-end mt-3">
                <mat-paginator [length]="totalRecord" [pageIndex]="currentPage" [pageSize]="size"
                               [pageSizeOptions]="[5, 10, 25, 100]"
                               aria-label="Select page" showFirstLastButtons color="warn"
                               (page)="pageChange($event)">
                </mat-paginator>
            </div>-->
            <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
              <mat-paginator
                [length]="totalRecord"
                [pageIndex]="pagination.currentPage"
                [pageSize]="pagination.size"
                [pageSizeOptions]="[5, 10, 25, 100, 200, 300]"
                aria-label="Select page"
                showFirstLastButtons
                color="warn"
                (page)="pageChange($event)">
              </mat-paginator>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Upload Modal -->
<div #bulkUpload class="modal app-modal" tabindex="-1" role="dialog" aria-labelledby="bulkUploadTitle">
  <div class="modal-dialog bulk-upload-dialog" role="document">
    <div class="modal-content bulk-upload-modal">
      <div class="bulk-upload-header">
        <div class="bulk-upload-title-wrap">
          <span class="bulk-upload-title-icon">
            <i class="fa-solid fa-file-arrow-up"></i>
          </span>
          <div>
            <h3 id="bulkUploadTitle" class="bulk-upload-title">Bulk Upload</h3>
            <p class="bulk-upload-subtitle">Upload the work-order file to add patients in bulk.</p>
          </div>
        </div>
        <button type="button" class="icon-close-btn" aria-label="Close" (click)="closeModal()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="bulk-upload-body">
        <div
          class="bulk-dropzone"
          [class.is-dragover]="isDragOver"
          [class.has-file]="files?.length > 0"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">

          <input
            type="file"
            #fileDropRef
            id="fileDropRef"
            (change)="onFilesSelected($event)"
            accept=".xls,.xlsx,.xlsm,.xlsb,.xltx,.xltm,.csv,.txt" />

          <ng-container *ngIf="!files?.length">
            <span class="dropzone-icon"><i class="fa-solid fa-cloud-arrow-up"></i></span>
            <h4>Drag and drop your file here</h4>
            <p>or <span class="browse-link">browse from your computer</span></p>
            <small>Excel / CSV files supported</small>
          </ng-container>

          <ng-container *ngIf="files?.length">
            <div class="selected-file-card" *ngFor="let file of files">
              <span class="selected-file-icon"><i class="fa-solid fa-file-excel"></i></span>
              <div class="selected-file-info">
                <div class="selected-file-name" [title]="file.name">{{ file.name }}</div>
                <div class="selected-file-meta">{{ formatFileSize(file.size) }} · Ready to upload</div>
              </div>
              <button
                type="button"
                class="remove-file-btn"
                aria-label="Remove selected file"
                (click)="removeImage(); $event.stopPropagation()">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </ng-container>
        </div>

        <div class="template-card">
          <div class="template-card-copy">
            <span class="template-card-icon"><i class="fa-solid fa-table-list"></i></span>
            <div>
              <div class="template-card-title">Need the correct format?</div>
              <div class="template-card-text">Use the latest work-order template before uploading.</div>
            </div>
          </div>
          <a
            href="assets/templates/workorder-upload-template.xlsx"
            download
            class="toolbar-btn toolbar-btn-light template-download-btn">
            <i class="fa-solid fa-download"></i>
            Download Template
          </a>
        </div>

        <div *ngIf="errorMessagePart" class="upload-error-panel">
          <div class="upload-error-title">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ errorMessagePart }}</span>
          </div>
          <ul *ngIf="errorMessages?.length">
            <li *ngFor="let error of errorMessages">{{ error }}</li>
          </ul>
        </div>
      </div>

      <div class="bulk-upload-footer">
        <button type="button" class="toolbar-btn toolbar-btn-light" (click)="closeModal()">
          Cancel
        </button>
        <button
          type="button"
          class="toolbar-btn toolbar-btn-primary"
          [disabled]="!files?.length"
          (click)="uploadFiles()">
          <i class="fa-solid fa-cloud-arrow-up"></i>
          Upload File
        </button>
      </div>
    </div>
  </div>
</div>
